<template>
  <div>
    <b-row class="steps-tunnel justify-content-center">
      <b-col cols="12" md="8">
        <b-row>
          <!-- step1 btn -->
          <b-col cols="auto step-btn-block my-auto">
            <div class="step-text">{{ $t("catalogs.catalog_name") }}</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 1 }"
              @click="changeStep(1)"
            >
              1
            </b-button>
          </b-col>
          <b-col class="step-line my-auto"></b-col>
          <!-- step2 btn -->
          <b-col cols="auto step-btn-block my-auto">
            <div class="step-text">{{ $t("general.etiquettes") }}</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 2 }"
              :disabled="!step1ok && isNew"
              @click="changeStep(2)"
            >
              2
            </b-button>
          </b-col>
          <b-col class="step-line my-auto"></b-col>
          <!-- step3 btn -->
          <b-col cols="auto step-btn-block  my-auto">
            <div class="step-text">{{ $t("general.list_de_resolution") }}</div>
            <b-button
              class="button btn-step"
              :class="{ 'btn-step-active': currentStep == 3 }"
              :disabled="!step2ok && isNew"
              @click="changeStep(3)"
            >
              3
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- .. -->
    <div v-if="!isLoadingInit">
      <appStep1
        v-if="currentStep == 1"
        ref="step-1"
        :resolution-catalog="resolutionCatalog"
        @updateCatalog="updateCatalog"
      />
      <appStep2
        v-if="currentStep == 2"
        :resolution-catalog="resolutionCatalog"
        @updateCatalog="updateCatalog"
      />
      <appStep3
        v-if="currentStep == 3"
        :resolution-catalog-id="resolutionCatalog.id"
        @hideParentActionButtons="hideActionButtons = $event"
      />

      <!-- cancel, create, update -->
      <b-row v-if="!hideActionButtons" class="mt-5 mb-2 justify-content-center">
        <b-col cols="auto">
          <b-button class="button btn-red" @click="cancel">
            <font-awesome-icon class="agv-button-icon" icon="times-circle" />
            <span>{{ $t("general.cancel") }}</span>
          </b-button>
        </b-col>
        <b-col cols="auto">
          <b-button
            v-if="isNew && currentStep !== 3"
            :disabled="isLoadingSave"
            class="button btn-blue"
            @click="goToNextStep"
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="arrow-right" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("general.continue") }}</span>
          </b-button>
          <b-button
            v-else
            :disabled="isLoadingSave"
            class="button btn-blue"
            @click="UPDATE_RES_CATALOG"
          >
            <font-awesome-icon v-if="!isLoadingSave" class="agv-button-icon" icon="save" />
            <font-awesome-icon v-else class="agv-button-icon" icon="spinner" pulse />
            <span>{{ $t("general.enregistrer") }}</span>
          </b-button>
        </b-col>
      </b-row>
    </div>
    <appLoader v-else />
  </div>
</template>

<script>
import { validate } from "vee-validate";

import appStep1 from "./Step1";
import appStep2 from "./Step2";
import appStep3 from "./Step3";

import ResolutionCatalogMW from "@/middlewares/ResolutionCatalog";
import ResolutionCatalogORM from "@/store/orm-axios/models/ResolutionCatalog";
import MajorityMW from "@/middlewares/Majority";

export default {
  components: {
    appStep1,
    appStep2,
    appStep3,
  },
  props: {
    isNew: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      currentStep: 1,
      step1ok: false,
      step2ok: false,
      hideActionButtons: false,
      isLoadingInit: true,
      isLoadingSave: false,
      resolutionCatalog: {
        agency_id: Number(localStorage.getItem("agencyId")),
        name: "",
        tags: [],
        resolutions: [],
      },
    };
  },
  async created() {
    if (!this.isNew) {
      await ResolutionCatalogMW.GET(this.$route.params.id)
        .then(res => {
          this.isLoadingInit = false;
          this.resolutionCatalog = ResolutionCatalogORM.query()
            .where("id", this.$route.params.id)
            .withAllRecursive()
            .first();
        })
        .catch(err => {
          this.isLoadingInit = false;
          console.log("error", err);
        });
    } else {
      this.isLoadingInit = false;
    }
    // Fetch majorities in order to be used on step 3 table -> resolution summary button
    await MajorityMW.FETCH();
  },
  mounted() {
    // EX: position steps tunnel texts
    this.setStepTextsStyles();
  },
  methods: {
    updateCatalog(key, value) {
      this.resolutionCatalog[key] = value;
    },
    async validateStep() {
      var valid = true;
      if (this.currentStep == 1) {
        await validate(this.resolutionCatalog.name, "required", {}).then(res => {
          if (!res.valid) {
            valid = false;
            this.$refs["step-1"].$refs["vee-catalog-name"].validate();
          }
        });
      }
      return valid;
    },
    async changeStep(stepNb) {
      if (!(await this.validateStep())) {
        return;
      }

      this.currentStep = stepNb;
    },
    async goToNextStep() {
      if (!(await this.validateStep())) {
        return;
      }

      if (this.currentStep == 1 && !this.resolutionCatalog.id) {
        this.CREATE_RES_CATALOG();
      } else {
        if (this.currentStep == 1) this.step1ok = true;
        if (this.currentStep == 2) this.step2ok = true;
        this.currentStep++;
      }
    },
    cancel() {
      this.$router.push({ name: "resolutions-catalogs" });
    },
    async CREATE_RES_CATALOG() {
      this.isLoadingSave = true;
      ResolutionCatalogMW.POST(this.resolutionCatalog)
        .then(res => {
          this.isLoadingSave = false;
          this.resolutionCatalog = ResolutionCatalogORM.query()
            .where("id", res.id)
            .withAllRecursive()
            .first();
          this.goToNextStep();
        })
        .catch(err => {
          this.isLoadingSave = false;
          console.log("err", err);
        });
    },
    async UPDATE_RES_CATALOG() {
      if (!(await this.validateStep())) {
        return;
      }

      this.isLoadingSave = true;
      ResolutionCatalogMW.PUT(this.resolutionCatalog)
        .then(res => {
          this.isLoadingSave = false;
          this.$router.push({ name: "resolutions-catalogs" });
        })
        .catch(err => {
          this.isLoadingSave = false;
          console.log("err", err);
        });
    },
  },
};
</script>
